package com.vamvisions.main.core.presentation.i18n

object EnStrings : Strings {
    override val navHome = "Home"
    override val navPortfolio = "Portfolio"
    override val navProjects = "Projects"
    override val navContact = "Contact"
    override val mainNavigationLabel = "Main navigation"
    override val skipToContent = "Skip to main content"

    override val switchToDarkScheme = "Switch to dark theme"
    override val switchToLightScheme = "Switch to light theme"
    override val changeLanguage = "Change language"

    override val homeTitle = "Home"
    override val portfolioTitle = "Portfolio"
    override val projectsTitle = "Projects"
    override val contactTitle = "Contact"
    override val notFoundTitle = "Page not found"

    override val notFoundMessage = "The page you are looking for does not exist."
    override val backToHome = "Back to the home page"

    override val errorNoConnection = "Could not reach the server. Check your connection and try again."
    override val errorNotFound = "The requested content could not be found."
    override val errorServer = "Something went wrong on the server. Please try again later."
    override val errorInvalidResponse = "The server sent a response that could not be read."
    override val errorUnknown = "Something went wrong. Please try again."
    override val errorBadRequest = "The message could not be accepted. Check the fields and try again."
    override val errorTooManyRequests = "Too many messages were sent. Please try again later."

    override val loading = "Loading…"
    override val retry = "Retry"

    override val introTitle = "\uD83C\uDF40 Hi, I'm Ana Maria Vilcu"
    override val introSubtitle = "I build Kotlin Multiplatform apps — and I love turning ideas into products people enjoy."
    override val highlightExperienceUnit = "years"
    override fun highlightExperienceTitle(years: Int) = "$years+ years"
    override val highlightExperienceAccent = "of professional experience"
    override val highlightExperienceText = "Building Android apps since 2018, from payment terminals and banking to consumer apps on Google Play."
    override val highlightTechnicalTitle = "Technical skills"
    override val highlightTechnicalAccent = "Mentored by Philipp Lackner & team"
    override val highlightTechnicalText = "Live Q&A sessions with Philipp and Slack support from his team while I build with Kotlin Multiplatform."
    override val highlightBusinessTitle = "Business skills"
    override val highlightBusinessAccent = "Mentored by Iman Gadzhi’s Monetise team"
    override val highlightBusinessText = "Several Q&A sessions every week on growing a product and scaling it."

    override val connectTitle = "\uD83E\uDD1D Let's connect"
    override val connectText = "Have a project in mind, a question about my work or just want to say hi? I'd love to hear from you."
    override val connectLink = "Get in touch"

    override val portfolioIntroTitle = "\uD83C\uDF31 My path so far"
    override val portfolioIntroText = "Today I build Kotlin Multiplatform apps under my own name, VAMVisions, backed by seven years in Android " +
        "product teams and a year invested in growing my skills."
    override val portfolioExperienceEyebrow = "Experience"
    override val portfolioExperienceTitle = "From product teams to my own studio"
    override val portfolioLearningEyebrow = "Learning now"
    override val portfolioLearningTitle = "Always learning"
    override val portfolioEducationEyebrow = "Education"
    override val portfolioEducationTitle = "Where it started"
    override val portfolioSeeProjects = "See my projects"
    override val portfolioWorkWithMe = "Work with me"

    override val contactIntroTitle = "\uD83D\uDC4B Let’s talk"
    override val contactIntroText = "Have an app idea, a digital product in mind or a partnership to explore? Tell me a little about it. I’d love " +
        "to hear from you."
    override val contactPhotoAlt = "Ana Maria Vîlcu smiling in a Japanese garden in Kyoto"
    override val contactReachTitle = "Reach me directly"
    override val contactFormTitle = "Tell me about it"
    override val contactTopicLabel = "What’s it about?"
    override val contactOptional = "(optional)"
    override val contactTopicAppDevelopment = "App development"
    override val contactTopicDigitalProduct = "Digital product creation"
    override val contactTopicPartnership = "Partnership"
    override val contactTopicOther = "Other"
    override val contactNameLabel = "Name (optional)"
    override val contactNamePlaceholder = "How should I call you?"
    override val contactEmailLabel = "Your email"
    override val contactEmailPlaceholder = "you@example.com"
    override val contactMessageLabel = "Message"
    override val contactMessagePlaceholder = "A few lines about your idea, timeline or question…"
    override val contactSend = "Send message"
    override val contactSending = "Sending…"
    override val contactSent = "Thank you! Your message was sent. I’ll get back to you soon."
    override val contactSendFailed = "Something went wrong and your message wasn’t sent. Please try again, or email me directly."
    override val errorFieldRequired = "This field is required."
    override val errorEmailInvalid = "Please enter a valid email address."
    override val errorMessageRequired = "Please write a message."
    override val errorMessageTooShort = "The message must have at least 10 characters."
    override val errorMessageTooLong = "The message must have at most 5000 characters."
    override val errorNameTooLong = "The name must have at most 100 characters."

    override val projectsIntroTitle = "\uD83D\uDEE0\uFE0F Things I’ve built"
    override val projectsIntroText = "From my first Java apps on Google Play to Kotlin Multiplatform products today. Each one taught me something I " +
        "bring to every new project."
    override val projectsNowEyebrow = "Now"
    override val projectsNowTitle = "What I’m building"
    override val projectsEarlierEyebrow = "Earlier apps · 2018–2021"
    override val projectsEarlierTitle = "Where it all started"
    override val projectsConnectTitle = "\uD83E\uDD1D Got an idea for an app?"
    override val projectsConnectText = "I’d love to hear about it. Let’s see how we can build it together."
    override val comingSoon = "Coming soon"
    override val visitSite = "Visit site"
    override val privacyPolicy = "Privacy policy"
    override val sourceCode = "Source code"

    override val documentTable = "Table"

    override val present = "now"
    override val shortMonthNames = listOf(
        "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
    )

    override val openMenu = "Open menu"
    override val closeMenu = "Close menu"
}
